import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { CrmService } from "../../../../servicios/crm.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MediaMatcher } from "@angular/cdk/layout";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-historial-config-cuotas-gestor-proyectos",
  templateUrl: "./historial-config-cuotas-gestor-proyectos.component.html",
  styleUrls: ["./historial-config-cuotas-gestor-proyectos.component.css"],
})
export class HistorialConfigCuotasGestorProyectosComponent implements OnInit {
  mobileQuery: MediaQueryList;
  private readonly _mobileQueryListener: () => void;

  public cuentaGestorProyectos: any;

  constructor(
    private crmservice: CrmService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<HistorialConfigCuotasGestorProyectosComponent>
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 750px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.cuentaGestorProyectos = data.cuentaGestorProyectos;
  }

  ngOnInit(): void {}

  public dameNombreUsuario(id: string): string {
    const pos = this.crmservice.usuarios.findIndex((e) => e._id === id);
    if (pos !== -1) {
      return (
        this.crmservice.usuarios[pos].nombre +
        " " +
        this.crmservice.usuarios[pos].apellidos.split(" ")[0]
      );
    } else {
      return "Desconocido";
    }
  }

  mostrarValorEnMBytes(bytes: number): string {
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(2).replace(".", ",")} MB`;
  }

  mostrarValorEnHoras(milisegundos: number): string {
    const horas = (milisegundos / (1000 * 60 * 60))
      .toFixed(2)
      .replace(".", ",");
    return `${horas}h`;
  }

  mostrarValorEnHorasYMinutos(milisegundos: number): string {
    const horas = milisegundos / (1000 * 60 * 60);
    const horasEnteras = Math.floor(horas);
    const minutos = Math.round((horas - horasEnteras) * 60);
    return `${horasEnteras}h ${minutos}m`;
  }
}
